import { Badge } from "V2.0/common/badge";
import { RunStatus } from "./models";

const Colors = {
  [RunStatus.Completed]: "green",
  [RunStatus.Cancelled]: "orange",
  [RunStatus.Failed]: "red",
  [RunStatus.Paused]: "yellow",
  [RunStatus.Running]: "emerald",
  [RunStatus.Scheduled]: "blue",
};

function PipelineRunStatus(props) {
  const { status } = props;

  return <Badge color={Colors[status]}>{status}</Badge>;
}

export { PipelineRunStatus };
